import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage, languages } = useLanguage();
  const { t } = useTranslation('navigation');

  // Find the alternative language (opposite of current)
  const getAlternativeLanguage = () => {
    if (currentLanguage === 'ar') {
      return languages.find(lang => lang.code === 'en');
    } else if (currentLanguage === 'en') {
      return languages.find(lang => lang.code === 'ar');
    }
    // Fallback: if current language is neither ar nor en, show the first available alternative
    return languages.find(lang => lang.code !== currentLanguage);
  };

  const alternativeLang = getAlternativeLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="glass" 
          size="sm" 
          className="hover:bg-ecosafe-green/20 border-ecosafe-green/30 text-white hover:text-white transition-all duration-300 hover:scale-105"
        >
          <Globe className="h-4 w-4 mr-2" />
          {alternativeLang?.nativeName}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="bg-white/95 backdrop-blur-lg border border-ecosafe-green/20 shadow-2xl rounded-xl"
      >
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            className={`cursor-pointer transition-all duration-300 rounded-lg mx-1 my-1 ${
              currentLanguage === language.code 
                ? 'bg-ecosafe-green/10 text-ecosafe-green-dark font-bold border border-ecosafe-green/20' 
                : 'hover:bg-ecosafe-green/5 text-ecosafe-black hover:text-ecosafe-green-dark'
            }`}
          >
            <Globe className={`h-4 w-4 mr-2 ${
              currentLanguage === language.code ? 'text-ecosafe-green' : 'text-ecosafe-gray'
            }`} />
            {language.nativeName}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
